export default "__VITE_ASSET__626f8f75__"